{
	"type": "line",
	"minzoom": 8,
	"layout": {
		"line-sort-key": [
			"match",
			["get", "sz_speed"],
			"10 km/h",
			1,
			"20 km/h",
			2,
			"30 km/h",
			3,
			"40 km/h",
			4,
			"50 km/h",
			5,
			"60 km/h",
			6,
			"70 km/h",
			7,
			"80 km/h",
			8,
			"90 km/h",
			9,
			"100 km/h",
			10,
			"110 km/h",
			11,
			1
		]
	},
	"paint": {
		"line-color": [
			"match",
			["get", "sz_speed"],
			"10 km/h",
			"#f789d8",
			"20 km/h",
			"#6b6bd6",
			"30 km/h",
			"#6e0e21",
			"40 km/h",
			"#a7c636",
			"50 km/h",
			"#999999",
			"60 km/h",
			"#f51400",
			"70 km/h",
			"#ffde3e",
			"80 km/h",
			"#fc921f",
			"90 km/h",
			"#3caf99",
			"100 km/h",
			"#149ece",
			"110 km/h",
			"#b7814a",
			"#ddd"
		],
		"line-width": 2
	}
}
